import { MenuList, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomMenuList = styled(MenuList)(({ theme }) => {
    return {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    };
});

export default forwardRef((props, ref) => {
    return <CustomMenuList ref={ref} {...props} />;
});
